import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_SIMUCOACH_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

export default axiosClient;